<template>
  <hm-content title>
    <div class="flex flex-between item-center mb20">
      <div class="flex">
        <el-button type="primary" size="small" @click="AddServiceProject"
          >新增服务预约</el-button
        >
      </div>
      <div class="table-panel flex flex-end">
        <el-select v-model="searchCondition.serviceTypeId" placeholder="请选择服务类型" class="mr10" size="small" filterable clearable>
            <el-option
                  :label="item.serviceType"
                  :value="item.id"
                  v-for="(item,index) in serviceTypeList"
                  :key="index"
            >
            </el-option>
        </el-select>
        <el-input class="mr10" size="small" placeholder="请输入服务名称" v-model="searchCondition.serviceProjectName" clearable></el-input>
        <el-button  class="mr10" size="small" type="primary" @click="queryList">查询</el-button>
        <el-button  class="mr10"
          size="small"
          type="primary"
          @click="output"
          :loading="isOutputing">导出
        </el-button>

      </div>  
    </div>
    <div>
      <el-table
        stripe
        border
        :data="serviceProject"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceType"
          label="服务类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceProjectName"
          label="服务名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState === 'yes'" class="success"
              >开启</span
            >
            <span v-if="scope.row.enabledState === 'no'" class="gray"
              >关闭</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="sortNum"
          label="排序"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="applyNum"
          label="已预约人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeNum"
          label="已核销人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
               <!-- <el-button
                type="text"
                class="blue"
                size="small"
                @click="productQrcode(scope.row)"
                >二维码</el-button
              > -->
               <el-button
                type="text"
                class="blue"
                size="small"
                @click="toDetails(scope.row)"
                >查看</el-button
              > 
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChanges"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      serviceProject:[],   
      total:0,   
      searchCondition:{},
      serviceTypeList:[],
      isOutputing: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryServiceRestorationTypeList();
    this.queryList();
  },
  methods: {
    AddServiceProject() {
      this.$router.push({ name: "AddServiceProject" });
    },
    toDetails(row){
      this.$router.push({
        name: "ServiceActivityList",
        query: {
          id: row.id
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditServiceProject",
        query: {
          id: row.id
        }
      });
    },
    async queryServiceRestorationTypeList() {
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationTypeList",
        {}
      );
      if (result) {
        this.serviceTypeList = result.records;
      }
    }, 
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryServiceRestorationProjectList",
          params
        );
        const { records, total } = result;
        this.serviceProject = records;
        this.total = total;

    },
    switchTab() {
      this.rightData = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.rightCheckAll = false;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // async productQrcode(id) {
    //   let params = `id=${id}`;

    //   const url = await this.$store.dispatch("shareDataSave", {
    //     url: params
    //   });

    //   const { result } = await this.$store.dispatch("createCouponQrcode", {
    //     path: `serviceReservation/serviceReservationDetail?saveUUID=${url.result}`
    //   });
    //   this.qrcodeDialogVisible = true;
    //   this.activityCode = result;
    // },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList()
          .then((v) => {
            const list = this.serviceProject;
            list.forEach(v => {
              if(v.enabledState==='yes'){
                v.enabledState = '开启'
              }else if(v.enabledState==='no'){
                v.enabledState = '关闭'
              }
            });
            const tHeader = [
              "服务类型",
              "服务名称",
              "创建时间",
              "状态",              
              "已预约人数",
              "已核销人数",
            ];
            const filterVal = [
              "serviceType",
              "serviceProjectName",
              "createTime",
              "enabledState",              
              "applyNum",
              "chargeNum",
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "服务预约列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },


  },
};
</script>
<style lang="scss" scoped>

</style>
